/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelQuoteOrder.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/quote-order";

export class AutogenModelQuoteOrder<RowType extends ModelRow> extends Endpoint<RowType, RowQuoteOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowQuoteOrder extends ModelRow<RowQuoteOrderFields> {
	constructor(values?: Partial<RowQuoteOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowQuoteOrderFields {
	actual_reefer_profile: string;
	agency_id: string;
	agent_payee_id: string;
	allow_relay: string;
	autorate_status: string;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	bol_note: string;
	bol_received: string;
	bol_recv_date: Date;
	booking_no: string;
	booking_number: string;
	brk_qual_profile: string;
	broker_location_id: string;
	brokerage_workflow_id: string;
	cbp_crossing_date: Date;
	cbp_crossing_location_id: string;
	cbp_crossing_reason: string;
	cbsa_crossing_date: Date;
	cbsa_crossing_location_id: string;
	cbsa_crossing_reason: string;
	cc_fuel_revenue: number;
	cc_fuel_revenue_c: string;
	cc_fuel_revenue_d: Date;
	cc_fuel_revenue_n: number;
	cc_fuel_revenue_r: number;
	cc_net_revenue: number;
	cc_net_revenue_c: string;
	cc_net_revenue_d: Date;
	cc_net_revenue_n: number;
	cc_net_revenue_r: number;
	cc_pro_nbr: string;
	cobroker_location_id: string;
	collection_method: string;
	com_setpnt_temp: number;
	com_setpnt_temp_um: string;
	commitment_id: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	consignee_refno: string;
	consignee_stop_id: string;
	container: string;
	container_planned: string;
	container_type_id: string;
	controlling_carrier_code: string;
	copy_from_company: string;
	copy_from_order_id: string;
	copy_to_company: string;
	copy_to_order_id: string;
	"ctrl_party.address1": string;
	"ctrl_party.address2": string;
	"ctrl_party.appt_required": string;
	"ctrl_party.assigned_to": string;
	"ctrl_party.bseg": string;
	"ctrl_party.category": string;
	"ctrl_party.cbsa_port_id": string;
	"ctrl_party.chassis_owner": string;
	"ctrl_party.chassis_pool": string;
	"ctrl_party.city_id": number;
	"ctrl_party.city_name": string;
	"ctrl_party.class_rqmt": string;
	"ctrl_party.comments": string;
	"ctrl_party.company_id": string;
	"ctrl_party.container_pool": string;
	"ctrl_party.container_vendor": string;
	"ctrl_party.cust_id": string;
	"ctrl_party.customer_id": string;
	"ctrl_party.days_between_calls": number;
	"ctrl_party.ded_rqmt_type": string;
	"ctrl_party.ded_type": string;
	"ctrl_party.def_commodity_desc": string;
	"ctrl_party.def_commodity_id": string;
	"ctrl_party.delivery_date_option": string;
	"ctrl_party.directions": string;
	"ctrl_party.disable_loc_rating": string;
	"ctrl_party.dl_gen_cost": number;
	"ctrl_party.dl_gen_repower": number;
	"ctrl_party.dl_haz_cost": number;
	"ctrl_party.dl_haz_repower": number;
	"ctrl_party.dl_hvl_cost": number;
	"ctrl_party.dl_hvl_repower": number;
	"ctrl_party.dl_load_time": number;
	"ctrl_party.dl_svc_cost": number;
	"ctrl_party.dl_svc_repower": number;
	"ctrl_party.dl_unload_time": number;
	"ctrl_party.driver_load_id": string;
	"ctrl_party.driver_unload_id": string;
	"ctrl_party.ds_capacity_cost": number;
	"ctrl_party.ds_model_flag": string;
	"ctrl_party.extra_handling_time": number;
	"ctrl_party.filer_code": string;
	"ctrl_party.foreign_port": string;
	"ctrl_party.friday_close": Date;
	"ctrl_party.friday_open": Date;
	"ctrl_party.fuel_price_region": string;
	"ctrl_party.google_place_fm_address": string;
	"ctrl_party.google_place_id": string;
	"ctrl_party.google_place_type": string;
	"ctrl_party.id": string;
	"ctrl_party.include_xref_trailers": string;
	"ctrl_party.insur_amt_rqrd": number;
	"ctrl_party.insur_amt_rqrd_c": string;
	"ctrl_party.insur_amt_rqrd_d": Date;
	"ctrl_party.insur_amt_rqrd_n": number;
	"ctrl_party.insur_amt_rqrd_r": number;
	"ctrl_party.is_active": string;
	"ctrl_party.is_consignee": string;
	"ctrl_party.is_customer": string;
	"ctrl_party.is_customs_broker": string;
	"ctrl_party.is_dist_center": string;
	"ctrl_party.is_dl_gen": string;
	"ctrl_party.is_dl_haz": string;
	"ctrl_party.is_dl_hvl": string;
	"ctrl_party.is_dl_svc": string;
	"ctrl_party.is_drop_yard": string;
	"ctrl_party.is_geocoded": string;
	"ctrl_party.is_outside_terminal": string;
	"ctrl_party.is_prospect": string;
	"ctrl_party.is_remote_terminal": string;
	"ctrl_party.is_shipper": string;
	"ctrl_party.is_steamship": string;
	"ctrl_party.is_terminal": string;
	"ctrl_party.is_trailer_pool": string;
	"ctrl_party.is_trailer_wash": string;
	"ctrl_party.is_truckstop": string;
	"ctrl_party.last_used_date": Date;
	"ctrl_party.latitude": number;
	"ctrl_party.layover": string;
	"ctrl_party.load_unload_count": number;
	"ctrl_party.load_unload_excl": string;
	"ctrl_party.load_unload_param": string;
	"ctrl_party.loading_instructs": string;
	"ctrl_party.loading_time": number;
	"ctrl_party.longitude": number;
	"ctrl_party.ltl_optimize_time_per_spot": number;
	"ctrl_party.ltl_seg_alloc_code": string;
	"ctrl_party.manual_exchange": string;
	"ctrl_party.max_drvr_complaint": number;
	"ctrl_party.max_pallet_balance": number;
	"ctrl_party.max_payment_code_amt": number;
	"ctrl_party.max_payment_code_amt_c": string;
	"ctrl_party.max_payment_code_amt_d": Date;
	"ctrl_party.max_payment_code_amt_n": number;
	"ctrl_party.max_payment_code_amt_r": number;
	"ctrl_party.model_flag": string;
	"ctrl_party.monday_close": Date;
	"ctrl_party.monday_open": Date;
	"ctrl_party.name": string;
	"ctrl_party.need_clean_trailer": string;
	"ctrl_party.next_call_date": Date;
	"ctrl_party.no_fuel_radius_inbound": string;
	"ctrl_party.no_fuel_radius_outbound": number;
	"ctrl_party.no_stop_miles": number;
	"ctrl_party.on_duty_not_driving_mins": number;
	"ctrl_party.pallet_balance": number;
	"ctrl_party.pallets_required": string;
	"ctrl_party.payment_api_excluded": string;
	"ctrl_party.pickup_date_option": string;
	"ctrl_party.plc_uid": number;
	"ctrl_party.pnn_city_id": number;
	"ctrl_party.pnn_city_name": string;
	"ctrl_party.pnn_state": string;
	"ctrl_party.pnn_zip_code": string;
	"ctrl_party.port_id": string;
	"ctrl_party.prev_code": string;
	"ctrl_party.primary_agency": string;
	"ctrl_party.radius": number;
	"ctrl_party.regulated": string;
	"ctrl_party.reload_rqmt": string;
	"ctrl_party.reserve_mins": number;
	"ctrl_party.salesperson": string;
	"ctrl_party.saturday_close": Date;
	"ctrl_party.saturday_open": Date;
	"ctrl_party.shuttle_capacity": string;
	"ctrl_party.state": string;
	"ctrl_party.sunday_close": Date;
	"ctrl_party.sunday_open": Date;
	"ctrl_party.swap_cost": number;
	"ctrl_party.team_rqmt": string;
	"ctrl_party.thursday_close": Date;
	"ctrl_party.thursday_open": Date;
	"ctrl_party.trailer_pool_min": number;
	"ctrl_party.trailer_pool_radius": number;
	"ctrl_party.trailer_pool_size": number;
	"ctrl_party.trailer_wash_vend": string;
	"ctrl_party.trimble_place_id": string;
	"ctrl_party.trip_starter": string;
	"ctrl_party.tuesday_close": Date;
	"ctrl_party.tuesday_open": Date;
	"ctrl_party.tw_seg_code": string;
	"ctrl_party.unload_instructs": string;
	"ctrl_party.unloading_time": number;
	"ctrl_party.website_url": string;
	"ctrl_party.wednesday_close": Date;
	"ctrl_party.wednesday_open": Date;
	"ctrl_party.zip_code": string;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	cust_order_no: string;
	customer_contact_name: string;
	customer_email: string;
	customer_fax: string;
	customer_id: string;
	customer_name: string;
	customer_phone: string;
	declared_val: number;
	def_move_type: string;
	default_match_id: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	dispatch_opt: string;
	dl_team_reqd: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	effective_date: Date;
	eir1_no: string;
	eir2_no: string;
	entered_user_id: string;
	equipment_type_id: string;
	equipment_type_options: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	excise_disable_update: string;
	excise_taxable: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	expiration_date: Date;
	external_invoiceno: string;
	extra_deliveries: number;
	extra_pickups: number;
	fgp_uid: number;
	floor_loaded_freight: string;
	force_assign: string;
	forwd_location_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	group_id: string;
	hazmat: string;
	hazmat_code: string;
	high_value: string;
	hold_reason: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	image_is_present: string;
	import_export: string;
	include_split_point: string;
	intelliset: string;
	invoice_recv_date: Date;
	is_auto_tonu: string;
	is_autorate_dist: string;
	is_billed: boolean;
	is_brokerage_ltl: boolean;
	is_container: string;
	is_dedicated: string;
	is_intercompany: string;
	is_local_mile: string;
	is_requested: string;
	is_tonu: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	loadboard: string;
	lock_miles: string;
	ltl: string;
	markup_flat: number;
	markup_flat_c: string;
	markup_flat_d: Date;
	markup_flat_n: number;
	markup_flat_r: number;
	markup_percent: number;
	master_order_id: string;
	master_sequence: number;
	next_rebill: string;
	notes: string;
	nte_lp_num: string;
	nte_lp_qual: string;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	optimize: string;
	optiset: string;
	order_mode: string;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_by_id: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_posting_city_id: number;
	pallets_how_many: number;
	pallets_required: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planning_comment: string;
	pnn_callback: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_loadboard_user_id: string;
	pnn_post_type: string;
	pnn_rate: number;
	pnn_rate_type: string;
	pnn_trailer_length: number;
	pnn_trailer_width: number;
	ponum: string;
	port: string;
	port_of_discharge: string;
	preload_trailer_id: string;
	preloaded: string;
	quote_status: string;
	rate: number;
	rate_currency_type: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_source: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	ready_to_bill: string;
	recurring_order_id: string;
	reply_transmitted: string;
	requesting_company: string;
	return_temp: number;
	return_temp_um: string;
	return_temp_var: number;
	return_temp_var_um: string;
	revenue_code_id: string;
	revenue_share_method: string;
	rf_entry_code_required: boolean;
	round_trip: string;
	sail_date: Date;
	salesperson_id: string;
	seal_number: string;
	seg_alloc_code: string;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	ship_status_to_edi: string;
	shipment_id: string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	show_equipment_type_options: boolean;
	ss_location_id: string;
	status: string;
	"stop_consignee.actual_arrival": Date;
	"stop_consignee.actual_departure": Date;
	"stop_consignee.address": string;
	"stop_consignee.address2": string;
	"stop_consignee.appointment_status_id": string;
	"stop_consignee.appt_contact_name": string;
	"stop_consignee.appt_required": string;
	"stop_consignee.cases": number;
	"stop_consignee.city_id": number;
	"stop_consignee.city_name": string;
	"stop_consignee.company_id": string;
	"stop_consignee.confirmed": string;
	"stop_consignee.contact_email": string;
	"stop_consignee.contact_name": string;
	"stop_consignee.dist_from_prev": number;
	"stop_consignee.dist_from_prev_um": string;
	"stop_consignee.driver_load_unload": string;
	"stop_consignee.edi_code": string;
	"stop_consignee.edi_loc_code": string;
	"stop_consignee.eta": Date;
	"stop_consignee.eta_distance": number;
	"stop_consignee.eta_late": string;
	"stop_consignee.eta_oor": string;
	"stop_consignee.google_place_id": string;
	"stop_consignee.grouped_id": number;
	"stop_consignee.hub": number;
	"stop_consignee.ic_stop_id": string;
	"stop_consignee.id": string;
	"stop_consignee.inbound_status": string;
	"stop_consignee.late_eta_colorcode": string;
	"stop_consignee.late_route_status": string;
	"stop_consignee.latitude": number;
	"stop_consignee.location_id": string;
	"stop_consignee.location_name": string;
	"stop_consignee.longitude": number;
	"stop_consignee.manifest_fgp_uid": number;
	"stop_consignee.manifest_reg_uid": number;
	"stop_consignee.move_dist_from_preassign": number;
	"stop_consignee.move_dist_from_preassign_um": string;
	"stop_consignee.move_dist_from_previous": number;
	"stop_consignee.move_dist_from_previous_um": string;
	"stop_consignee.movement_id": string;
	"stop_consignee.movement_sequence": number;
	"stop_consignee.operational_status": string;
	"stop_consignee.order_id": string;
	"stop_consignee.order_sequence": number;
	"stop_consignee.orig_sched_early": Date;
	"stop_consignee.orig_sched_late": Date;
	"stop_consignee.pallets_dropped": number;
	"stop_consignee.pallets_picked_up": number;
	"stop_consignee.payment_code_reviewed": string;
	"stop_consignee.phone": string;
	"stop_consignee.planned_arrival_time": Date;
	"stop_consignee.ponum": string;
	"stop_consignee.prior_uncleared_stops": string;
	"stop_consignee.projected_arrival": Date;
	"stop_consignee.pu_override_arrive_early": Date;
	"stop_consignee.pu_override_arrive_late": Date;
	"stop_consignee.rate_dist_from_previous": number;
	"stop_consignee.rate_dist_from_previous_um": string;
	"stop_consignee.refno": string;
	"stop_consignee.requested_service": string;
	"stop_consignee.sched_arrive_early": Date;
	"stop_consignee.sched_arrive_late": Date;
	"stop_consignee.seal": string;
	"stop_consignee.service_date": Date;
	"stop_consignee.showas_address": string;
	"stop_consignee.showas_address2": string;
	"stop_consignee.showas_city_id": number;
	"stop_consignee.showas_city_name": string;
	"stop_consignee.showas_location_id": string;
	"stop_consignee.showas_location_name": string;
	"stop_consignee.showas_state": string;
	"stop_consignee.showas_zip_code": string;
	"stop_consignee.signed_for_name": string;
	"stop_consignee.state": string;
	"stop_consignee.status": string;
	"stop_consignee.stop_type": string;
	"stop_consignee.trimble_place_id": string;
	"stop_consignee.txl_uid": number;
	"stop_consignee.volume": number;
	"stop_consignee.volume_um": string;
	"stop_consignee.weight": number;
	"stop_consignee.weight_um": string;
	"stop_consignee.zip_code": string;
	"stop_consignee.zone_id": string;
	"stop_origin.actual_arrival": Date;
	"stop_origin.actual_departure": Date;
	"stop_origin.address": string;
	"stop_origin.address2": string;
	"stop_origin.appointment_status_id": string;
	"stop_origin.appt_contact_name": string;
	"stop_origin.appt_required": string;
	"stop_origin.cases": number;
	"stop_origin.city_id": number;
	"stop_origin.city_name": string;
	"stop_origin.company_id": string;
	"stop_origin.confirmed": string;
	"stop_origin.contact_email": string;
	"stop_origin.contact_name": string;
	"stop_origin.dist_from_prev": number;
	"stop_origin.dist_from_prev_um": string;
	"stop_origin.driver_load_unload": string;
	"stop_origin.edi_code": string;
	"stop_origin.edi_loc_code": string;
	"stop_origin.eta": Date;
	"stop_origin.eta_distance": number;
	"stop_origin.eta_late": string;
	"stop_origin.eta_oor": string;
	"stop_origin.google_place_id": string;
	"stop_origin.grouped_id": number;
	"stop_origin.hub": number;
	"stop_origin.ic_stop_id": string;
	"stop_origin.id": string;
	"stop_origin.inbound_status": string;
	"stop_origin.late_eta_colorcode": string;
	"stop_origin.late_route_status": string;
	"stop_origin.latitude": number;
	"stop_origin.location_id": string;
	"stop_origin.location_name": string;
	"stop_origin.longitude": number;
	"stop_origin.manifest_fgp_uid": number;
	"stop_origin.manifest_reg_uid": number;
	"stop_origin.move_dist_from_preassign": number;
	"stop_origin.move_dist_from_preassign_um": string;
	"stop_origin.move_dist_from_previous": number;
	"stop_origin.move_dist_from_previous_um": string;
	"stop_origin.movement_id": string;
	"stop_origin.movement_sequence": number;
	"stop_origin.operational_status": string;
	"stop_origin.order_id": string;
	"stop_origin.order_sequence": number;
	"stop_origin.orig_sched_early": Date;
	"stop_origin.orig_sched_late": Date;
	"stop_origin.pallets_dropped": number;
	"stop_origin.pallets_picked_up": number;
	"stop_origin.payment_code_reviewed": string;
	"stop_origin.phone": string;
	"stop_origin.planned_arrival_time": Date;
	"stop_origin.ponum": string;
	"stop_origin.prior_uncleared_stops": string;
	"stop_origin.projected_arrival": Date;
	"stop_origin.pu_override_arrive_early": Date;
	"stop_origin.pu_override_arrive_late": Date;
	"stop_origin.rate_dist_from_previous": number;
	"stop_origin.rate_dist_from_previous_um": string;
	"stop_origin.refno": string;
	"stop_origin.requested_service": string;
	"stop_origin.sched_arrive_early": Date;
	"stop_origin.sched_arrive_late": Date;
	"stop_origin.seal": string;
	"stop_origin.service_date": Date;
	"stop_origin.showas_address": string;
	"stop_origin.showas_address2": string;
	"stop_origin.showas_city_id": number;
	"stop_origin.showas_city_name": string;
	"stop_origin.showas_location_id": string;
	"stop_origin.showas_location_name": string;
	"stop_origin.showas_state": string;
	"stop_origin.showas_zip_code": string;
	"stop_origin.signed_for_name": string;
	"stop_origin.state": string;
	"stop_origin.status": string;
	"stop_origin.stop_type": string;
	"stop_origin.trimble_place_id": string;
	"stop_origin.txl_uid": number;
	"stop_origin.volume": number;
	"stop_origin.volume_um": string;
	"stop_origin.weight": number;
	"stop_origin.weight_um": string;
	"stop_origin.zip_code": string;
	"stop_origin.zone_id": string;
	subject_order_number: string;
	subject_order_status: string;
	subject_order_void_date: Date;
	swap: string;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_type: string;
	vessel: string;
	vessel_cutoff_date: Date;
	voided_load_transmitted: string;
	voided_load_transmitted_dt: Date;
	weight: number;
	weight_um: string;
	xferred2billing: string;
	xferred2billing_dt: Date;
	days_back: number;
}

